export const STICKER = {
    "sleep": {
        "packageId": 1,
        "id": 1
    },
    "smile": {
        "packageId": 1,
        "id": 2
    },
    "surprise": {
        "packageId": 1,
        "id": 3
    },
    "admire": {
        "packageId": 1,
        "id": 4
    },
    "fun": {
        "packageId": 1,
        "id": 5
    },
    "angry": {
        "packageId": 1,
        "id": 6
    },
    "you": {
        "packageId": 1,
        "id": 7
    },
    "scare": {
        "packageId": 1,
        "id": 8
    },
    "cry": {
        "packageId": 1,
        "id": 9
    },
    "laugh": {
        "packageId": 1,
        "id": 10
    },
    "sing": {
        "packageId": 1,
        "id": 11
    },
    "fight": {
        "packageId": 1,
        "id": 13
    },
    "good": {
        "packageId": 1,
        "id": 13
    },
    "ok": {
        "packageId": 1,
        "id": 13
    }
};
//# sourceMappingURL=sticker.js.map